import axios from 'axios'
import { Loading, Message } from 'element-ui'
import store from '@/store'
// import ElementUI from 'element-ui';
axios.defaults.headers['Content-Type'] = 'application/json;charset=utf-8'
const service = axios.create({
    // baseURL: 'https://www.easy-mock.com/mock/test',
    // baseURL: 'http://49.232.148.196:9903',
    timeout: 200000
});

// 请求拦截器
service.interceptors.request.use(
    config => {
        // Loading.service({text: '拼命加载中...'});
        // console.log('config', config)
        config.headers['__ORIGIN__'] = 'WEB'
        // 是否需要设置 token
        // const isToken = (config.headers || {}).isToken === false
        // if (getToken() && !isToken) {
            // + getToken()
            // Admin-Token
            config.headers['Authorization'] = store.getters.token || '' // 让每个请求携带自定义token 请根据实际情况自行修改
        // }
        // 在发送请求之前做些什么
        return config;
    },
    error => {
        console.log(error);
        return Promise.reject();
    }
);

// 响应拦截器
service.interceptors.response.use(
    response => {
        const res = response.data
        // Loading.service().close()
        // 200是自定义的状态码，根据实际情况定义
        if(res.message != "短信"){
        if (res.code !== 0 || response.status !==200) {
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            /* 此处还可以写一些其他的逻辑处理 */
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
      }
      if(res.message == "短信"){
        let newRes =  JSON.parse(res.result);
        if (newRes.code != 0 || response.status !==200) {
            Message({
                message: res.msg || 'Error',
                type: 'error',
                duration: 5 * 1000
            })
            /* 此处还可以写一些其他的逻辑处理 */
            return Promise.reject(new Error(res.msg || 'Error'))
        } else {
            return res
        }
      }
    },
    error => {
        // Loading.service().close()
        console.log('err' + error)
        Message({
            message: error.msg || '接口请求失败',
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
)

export default service;


// WEBPACK FOOTER //
// ./src/assets/js/axiosUtil.js